// types.js
const SET_UI_STATE = 'account/ui/set-state';

export default {
    SET_UI_STATE,
}